import React from 'react';
import { useTheme } from '../hooks/useTheme';

const Rewards = () => {
    const { darkMode } = useTheme();

    return (
        <div className="max-w-4xl mx-auto px-4 py-8">
            <h2 className={`text-2xl font-bold ${darkMode ? 'text-white' : 'text-gray-900'} mb-6`}>🎁 Rewards</h2>

            <div className={`${darkMode ? 'bg-gray-800' : 'bg-white'} rounded-lg shadow p-12`}>
                <div className="text-center">
                    {/* Large Coming Soon Icon */}
                    <div className="mb-8">
                        <div className="text-8xl mb-4">🚧</div>
                    </div>

                    {/* Coming Soon Text */}
                    <h3 className={`text-3xl font-bold ${darkMode ? 'text-white' : 'text-gray-900'} mb-4`}>
                        Coming Soon!
                    </h3>

                    <p className={`text-lg ${darkMode ? 'text-gray-300' : 'text-gray-600'} mb-6 max-w-md mx-auto`}>
                        We're working on an exciting rewards system to make your fitness journey even more rewarding.
                    </p>

                    {/* Feature Preview */}
                    <div className={`${darkMode ? 'bg-gray-700 border-gray-600' : 'bg-gray-50 border-gray-200'} border rounded-lg p-6 max-w-lg mx-auto`}>
                        <h4 className={`text-lg font-semibold ${darkMode ? 'text-white' : 'text-gray-900'} mb-3`}>
                            What's Coming:
                        </h4>
                        <ul className={`text-left space-y-2 ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                            <li className="flex items-center gap-2">
                                <span className="text-green-500">✅</span>
                                Achievement badges for milestones
                            </li>
                            <li className="flex items-center gap-2">
                                <span className="text-green-500">✅</span>
                                Streak rewards and bonuses
                            </li>
                            <li className="flex items-center gap-2">
                                <span className="text-green-500">✅</span>
                                Point redemption system
                            </li>
                            <li className="flex items-center gap-2">
                                <span className="text-green-500">✅</span>
                                Special challenges and events
                            </li>
                            <li className="flex items-center gap-2">
                                <span className="text-green-500">✅</span>
                                Weekly and monthly leaderboards
                            </li>
                            <li className="flex items-center gap-2">
                                <span className="text-green-500">✅</span>
                                Virtual trophies and certificates
                            </li>
                        </ul>
                    </div>

                    {/* Progress Indicator */}
                    <div className="mt-8">
                        <div className={`${darkMode ? 'bg-gray-600' : 'bg-gray-200'} rounded-full h-2 max-w-xs mx-auto`}>
                            <div className="bg-blue-500 h-2 rounded-full w-1/3"></div>
                        </div>
                        <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-500'} mt-2`}>
                            Development Progress: 33%
                        </p>
                    </div>

                    {/* Motivational Message */}
                    <div className="mt-8">
                        <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                            Keep working out and earning points! 💪
                        </p>
                        <p className={`text-xs ${darkMode ? 'text-gray-500' : 'text-gray-400'} mt-2`}>
                            Your progress is being tracked and will count towards future rewards
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Rewards;